import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { trackEvent } from 'store/split/splitActions';
import { getBrowser } from 'store/userEnvironment/userEnvironmentSelectors';

export function useTrackSplitEvent() {
  const dispatch = useDispatch();
  const browser = useSelector(getBrowser);

  return useCallback(
    (event) => {
      dispatch(
        trackEvent({
          ...event,
          properties: {
            ...event.properties,
            browserType: browser.type,
          },
        }),
      );
    },
    [browser.type, dispatch],
  );
}
